"use client";

import Button from "../Button/Button";
import ShoppingCartIcon from "@heroicons/react/24/outline/ShoppingCartIcon";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";
import LockClosedIcon from "@heroicons/react/24/outline/LockClosedIcon";
import React from "react";
import {useCommerceContext} from "provider/magento/context";
import {useFrontendConfiguratorContext} from "../ProductConfigurator/context";
import {usePhrase} from "app/i18n";
import Script from "next/script";
import ProductShippingBox from "../ProductShippingBox/ProductShippingBox";
import {formatCurrencySymbol, formatPriceStyle} from "../../utilities/price";
import {Loader} from "../Loader/Loader";


const ProductBuyBox = ({
                           product,
                           config,
                           storeLocale,
                           quantity,
                           setQuantity,
                           itemId,
                           buyInProgress,
                           storeCode,
                           handleAddToCart,
                           handleUpdateCartItem,
                           returnPage,
                           _t
                       }) => {

    const t = usePhrase(_t);
    const {isLoadingCart} = useCommerceContext();
    const {currentConfiguration} = useFrontendConfiguratorContext();


    return <div className={'lg:sticky border rounded border-[#f5f5f5] w-full lg:top-48 lg:left-0 px-4 py-3'}>

        <div className={'mb-1'}>
            <p>{t('Total')}</p>
            <div className={`min-h-[32px]`}>
                {currentConfiguration && !isNaN(currentConfiguration.finalPriceGrandTotal) && currentConfiguration.finalPriceGrandTotal > 0 ? <>
                    <span id={'product_total_price_side'}
                          className={'text-xl font-bold'}>{formatPriceStyle(parseFloat(currentConfiguration.finalPriceGrandTotal).toFixed(2))} {formatCurrencySymbol(config.store?.default_display_currency_code)}</span>
                    {(!config?.customs_info || !config?.customs_info?.enable_table) && <span
                        className={'text-[#555] text-xs ml-2'}>{t('tax included')}</span>}
                </> : <Loader/>}
            </div>
        </div>


        {config.payment_methods && ['scalapay', 'paylater', 'payin3', 'payin4'].some(m => config.payment_methods.includes(m)) && currentConfiguration && !isNaN(currentConfiguration.finalPriceGrandTotal) && <>
            <div className={'text-sm !font-avertape mb-3 min-h-[42px]'}>
                <Script src={'https://cdn.scalapay.com/widget/v3/js/scalapay-widget.esm.js'} type={'module'}
                        strategy={'lazyOnload'}/>
                <Script src={'https://cdn.scalapay.com/widget/v3/js/scalapay-widget.js'} noModule
                        strategy={'lazyOnload'}/>
                <scalapay-widget
                    frequency-number='30'
                    number-of-installments='3'
                    hide='false'
                    hide-price='false'
                    min='5'
                    max='1500'
                    amount-selectors='["#product_total_price_side"]'
                    currency-position='after'
                    currency-display='symbol'
                    logo-size='100'
                    theme='primary'
                    locale={storeLocale.substr(0, 2)}
                    show-title='true'
                ></scalapay-widget>
            </div>
        </>}


        <div className={'mb-3 min-h-[140px]'}>
            <ProductShippingBox product={product} storeCode={storeCode} storeLocale={storeLocale}
                                storeTimezone={config.store?.timezone} light={true} _t={_t}/>
        </div>

        {/*        <div className={'mb-5'}>
            <p className={'text-sm'}>{t(`Returns are free, for more information see our`)}
                 <NFLink storeCode={storeCode} className="underline ml-1" href={returnPage?.url} target="_blank">{t('return policy')}</NFLink>
            </p>
        </div>*/}


        <div className={'mb-5'}>
            <span className={'text-green-700 text-lg font-bold'}>{t('Product available')}</span>
        </div>

        <div className={`min-h-[32px]`}>
            {currentConfiguration && !isNaN(currentConfiguration.finalPriceGrandTotal) && currentConfiguration.finalPriceGrandTotal > 0 &&
                <div className={'flex items-center mb-5'}>
                    <span className={'mr-3 text-sm'}>{t('Quantity')}:</span>
                    <input type="number" name={'quantity'} aria-label={t('Quantity')} value={quantity}
                           onChange={e => setQuantity(e.target.value)}
                           className={'w-16 h-8 border-2 border-gray-500 rounded'}/>
                </div>}
        </div>

        <div className={'flex flex-col'}>

            <Button
                id={'add_to_cart_button_side'}
                aria-label={t('Add to cart')}
                className={`${(isLoadingCart || !currentConfiguration || buyInProgress) ? 'disabled' : ''} bg-[#e7bb43] py-2 px-4 rounded text-center mb-2 relative`}
                disabled={isLoadingCart || !currentConfiguration || buyInProgress}
                onClick={() => itemId ? handleUpdateCartItem() : handleAddToCart(false)}>
                <span
                    className={`${storeCode.match('de') ? 'text-xs' : ''}`}>{itemId ? t('Update product') : t('Add to cart')}</span>
                <span className={'absolute top-0 h-full right-2 flex items-center'}>

                                        {buyInProgress ? <svg className="animate-spin text-black fill-white h-5 w-5"
                                                              viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                    strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor"
                                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg> : <ShoppingCartIcon
                                            className={`'w-4 h-4`}/>}

                                    </span>

            </Button>

            {!itemId && <Button aria-label={t('Buy now')}
                                className={'!bg-[#111213] !border-[#111213] py-2 px-4 rounded text-center'}
                                disabled={isLoadingCart || !currentConfiguration || buyInProgress}
                                onClick={() => handleAddToCart(true)}>
                <span className={'text-white'}>{t('Buy now')}</span>
                <span className={'absolute right-2 text-white'}>
                                        {buyInProgress ? <svg className="animate-spin text-black fill-white h-5 w-5"
                                                              viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                    strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor"
                                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg> : <ArrowRightIcon className={'w-5 h-5 mr-1'}/>}
                                    </span>
            </Button>}

            <div className={'flex items-center text-xs text-gray-600 mt-2'}>
                <span><LockClosedIcon className={'w-5 h-5 mr-1'}/></span>
                <span className={''}>{t('The transaction is safe')}</span>
            </div>

        </div>

    </div>

}


export default ProductBuyBox;